import { Link, useSearchParams } from 'react-router'
import { cn } from '#app/utils/misc'

export function CategoryFilter({ categories }: { categories: string[] }) {
	const [searchParams] = useSearchParams()
	const active = searchParams.get('category') ?? 'All'

	return (
		<div className="flex flex-wrap gap-2">
			{categories.map((cat) => {
				const params = new URLSearchParams(searchParams)
				if (cat === 'All') {
					params.delete('category')
				} else {
					params.set('category', cat)
				}

				return (
					<Link
						key={cat}
						to={`?${params.toString()}`}
						preventScrollReset
						className={cn(
							'rounded-full border px-4 py-2 text-sm font-medium transition-colors',
							active === cat
								? 'border-[#32302F] bg-[#32302F] text-white'
								: 'border-[#AEAEAE] bg-white text-[#32302F] hover:border-[#32302F]',
						)}
					>
						{cat}
					</Link>
				)
			})}
		</div>
	)
}
